import * as ActionTypes from "../app/ActionTypes";

import * as Services from "../webAPI/MKSService";

export function getProjectRequest(projectId) {
	return function (dispatch) {
		dispatch({
			type: ActionTypes.GET_PROJECT_REQUEST
		});
		return Services.getProject(projectId).then(
			(error) => {
				dispatch({
					type: ActionTypes.GET_PROJECT_FAIL,
					error
				});
			},
			(result) => {
				dispatch({
					type: ActionTypes.GET_PROJECT_SUCCESS,
					project: result
				});
			}
		);
	};
}

export function getCylindersTypesRequest() {
	return function (dispatch) {
		dispatch({
			type: ActionTypes.GET_CYLINDERS_TYPES_REQUEST,
		});

		return Services.getCylindersTypes().then(
			(error) => {
				dispatch({
					type: ActionTypes.GET_CYLINDERS_TYPES_FAIL,
					error
				});
			},
			(result) => {
				// Normalize
				let normalizedResult = {};
				for(let i = 0; i < result.length; i++) {
					normalizedResult[result[i].code] = {
						dimension_a: result[i].dimension_a,
						dimension_b: result[i].dimension_b,
					};
				}
				dispatch({
					type: ActionTypes.GET_CYLINDERS_TYPES_SUCCESS,
					result: normalizedResult
				});
			}
		);
	};
}



// WEBPACK FOOTER //
// ./src/js/plan/planActions.js